/* eslint-disable max-lines-per-function */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import RecentActorsIcon from '@mui/icons-material/RecentActors'
import {
  Box,
  Button,
  Card,
  Typography,
  Tooltip,
  ListItemButton,
  ListItemText,
} from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { MenuProps } from '~/components/SidebarMenu/interfaces'
import useUserState from '~/features/User/stores/UserState'
import { useHistory } from 'react-router-dom'
import AuditMenuItem from './components/AuditMenuItem' // Novo import

export default function AuditMenu({ activeMenu, handleMenuClick }: MenuProps) {
  const { translate } = useLang()
  const { verifyPermission } = useUserState()
  const history = useHistory()

  // Array de itens do menu de auditoria
  const auditMenuItems = [
    {
      permission: ['audit_user_logs_in_occurrences'],
      route: '/audit-user-actions',
      label: 'Actions in occurrence',
      tooltip: 'in occurrence',
    },
    {
      permission: ['occurrence_associated_search_log_index'],
      route: '/audit-qualifiers',
      label: 'Qualificators search',
      tooltip: 'Audit',
    },
    {
      permission: ['interest_point_log_index'],
      route: '/audit-interest-point',
      label: 'interest point',
      tooltip: 'Audit',
    },
    {
      permission: ['audit_user_logs_in_occurrences'],
      route: '/audit-user-loginLogout',
      label: 'Login/Logout',
      tooltip: 'login/logout',
    },
    {
      permission: ['audit_keywords_search_logs'],
      route: '/audit-keywords',
      label: 'Keywords',
      tooltip: 'Keywords',
    },
    {
      permission: ['audit_user_logs_in_occurrences'],
      route: '/audit-user-actions-report',
      label: 'Reports',
      tooltip: 'Reports',
    },
    {
      permission: ['audit_user_logs_in_occurrences'],
      route: '/audit-user-device',
      label: 'device',
      tooltip: 'device',
    },
    {
      permission: ['audit_dispatch_group_action_logs'],
      route: '/audit-user-dispatch-group',
      label: 'Dispatch group',
      tooltip: 'Dispatch group',
    },
    {
      permission: ['audit_group_action_logs'],
      route: '/audit-user-group',
      label: 'User group',
      tooltip: 'User group',
    },
    {
      permission: ['audit_dispatch_statistics_logs'],
      route: '/audit-dispatch-statistics',
      label: 'Dispatch statistics',
      tooltip: 'Dispatch statistics',
    },
    {
      permission: ['audit_printing_occurrrence_logs'],
      route: '/audit-print-occurrence',
      label: 'Print occurrence',
      tooltip: 'Print occurrence',
    },
    {
      permission: ['audit_user_action_logs'],
      route: '/audit-users',
      label: 'Users',
      tooltip: 'Users',
    },
    {
      permission: ['audit_station_action_logs'],
      route: '/audit-station',
      label: 'Stations',
      tooltip: 'Stations',
    },
    // {
    //   permission: ['audit_work_schedule_action_logs'],
    //   route: '/audit-scale',
    //   label: 'Scale Action Logs',
    //   tooltip: 'Scale Action Logs',
    // },
  ]

  return (
    <>
      {(verifyPermission(['interest_point_log_index']) ||
        verifyPermission(['occurrence_associated_search_log_index'])) && (
        <Box>
          <Tooltip title={translate('Audit')} placement="bottom">
            <Button
              className={`main-menu ${activeMenu == 'audit' ? 'active' : ''}`}
              onClick={() => handleMenuClick('audit')}
            >
              <RecentActorsIcon />
            </Button>
          </Tooltip>
          <Card
            className="submenu-box"
            sx={{
              borderRadius: 0,
              display: activeMenu == 'audit' ? 'block' : 'none',
            }}
          >
            <Typography variant="h4" sx={{ textAlign: 'center' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  gap: 1,
                }}
              >
                <RecentActorsIcon />
                {translate('Audit')}
              </Box>
            </Typography>

            {/* Renderiza os itens usando map */}
            {auditMenuItems.map((item) => (
              <AuditMenuItem
                key={item.route} // Chave única baseada na rota
                permission={item.permission}
                route={item.route}
                label={item.label}
                tooltip={item.tooltip}
                handleMenuClick={handleMenuClick}
                history={history}
              />
            ))}
          </Card>
        </Box>
      )}
    </>
  )
}
